"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delay = delay;
/**
 * Returns a promise that resolves after the given number of milliseconds.
 */

function delay(timeoutMilliseconds) {
  var timeoutId = void 0;
  var promise = new Promise(function (resolve, reject) {
    timeoutId = setTimeout(resolve, timeoutMilliseconds);
  });

  promise.cancel = function () {
    clearTimeout(timeoutId);
  };

  return promise;
} // TODO: Make more convenience functions that create promises.